import Plyr from "plyr";

const ELVideo = () => {
  window.addEventListener("load", function () {
    var players = document.querySelectorAll(".plyr-player");
    if (players)
      players.forEach((el) => {
        new Plyr(el);
      });
  });
};
export default ELVideo;
